import './../../../../../style/Vars.css';
import './../../../../../style/ContainersStyles.css';
import './../../../../../style/ElementsStyle.css';
import { isMobile, isTablet } from 'react-device-detect';
import { FaUserCircle, FaShieldAlt } from 'react-icons/fa';
import AvisosPrivacidadCatalog from './AvisosPrivacidadCatalog';

export default function AvisosPrivacidadPage() {
    const isSmall = isMobile || isTablet;

    return (
        <div className="panel-sigma-layout">
            <aside className={`panel-sigma-sidebar ${isSmall ? 'panel-sigma-sidebar-responsive' : ''}`}>
                {!isSmall && (
                    <div className="panel-sigma-avatar">
                        <FaUserCircle size={48} />
                    </div>
                )}
                <nav className="panel-sigma-nav">
                    <button title="Avisos de Privacidad" className="active"><FaShieldAlt /></button>
                </nav>
            </aside>

            <AvisosPrivacidadCatalog />
        </div>
    );
}
